import React, { useState } from 'react';
import { TextField, Button, Typography, CircularProgress } from '@mui/material';
import useUserService from '../../hooks/useUserService';
import { useSnackbar } from '../../components/SnackbarProvider';

function EmailResetPass() {
    const [user_email, setEmail] = useState(null);
    const { requestPasswordReset } = useUserService();
    const showSnackbar = useSnackbar();
    const [error, setError] = useState('');
    const [resetSent, setResetSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleResetClick = async () => {
        setLoading(true);
        setError('');
        try {
            const response = await requestPasswordReset(user_email);
            if (response.status === 200) {
                setResetSent(true);
                showSnackbar('Correo de restablecimiento enviado', 'success');
            }
        } catch (error) {
            const msg = error?.response?.data?.detail || 'Error al enviar el correo';
            setError(msg);
            showSnackbar(msg, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ maxWidth: 400, margin: 'auto', textAlign: 'center' }}>
            {!resetSent ? (
                <div>
                    <Typography variant="h5" gutterBottom>
                        Restablecer Contraseña
                    </Typography>
                    <TextField
                        label="Correo electrónico"
                        variant="outlined"
                        value={user_email}
                        onChange={handleEmailChange}
                        fullWidth
                        margin="normal"
                    />
                    {error && (
                        <Typography variant="body2" color="error">
                            {error}
                        </Typography>
                    )}
                    <Button
                        variant="contained"
                        onClick={handleResetClick}
                        sx={{ mt: 3, mb: 2, backgroundColor: '#E66136', color: 'white', '&:hover': { backgroundColor: '#913d21' } }}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} /> : 'Restablecer'}
                    </Button>
                </div>
            ) : (
                <Typography variant="body1" gutterBottom>
                    Por favor, siga las instrucciones indicadas en el email.
                </Typography>
            )}
        </div>
    );
}

export default EmailResetPass;
